<!--- START CONTENT --->
<div id="{{ identifier }}" class="h-100 {{ mobile ? 'is-mobile' : '' }}">
    <div class="h-100">
        <router-outlet #o="outlet"></router-outlet>
    </div>
</div>
<!--- END CONTENT --->